import React from 'react'
import calculateAbsolutePositions from './calculateAbsolutePositions'
import { CodeBlock } from './../CodeBlock'

export default class DraggableCodeList extends React.Component {
  handleMouseUp_ = () => {
    this.selectedCode_ = null
  }

  onClick_ = codeObj => {
    this.selectedCode_ = codeObj
  }

  handleMouseMove_ = () => {
    const { onCodeGrab } = this.props
    if (this.selectedCode_) onCodeGrab(this.selectedCode_)
  }

  componentDidMount = () => {
    document.body.addEventListener('mouseup', this.handleMouseUp_)
    document.body.addEventListener('mousemove', this.handleMouseMove_)
  }

  componentWillUnmount = () => {
    document.body.removeEventListener('mouseup', this.handleMouseUp_)
    document.body.removeEventListener('mousemove', this.handleMouseMove_)
  }

  render() {
    var { width, codes } = this.props

    if (!width) throw new Error('width must be passed in as props.')
    const dimensions = codes.map(
      // If it errors on .style here then you need to set the style for
      // all passed in children with a width and height numeric value.
      c => ({
        // We have to explicitly set the width/height so that its easy to animate
        // The 8.4 here is the size of a font character, we are using a monospace
        // font so that all character widths are the same
        width: c.title
          ? (c.title.length + c.code.length) * 8.4 + 40
          : c.code.length * 8.4 + 40,
        height: 40,
      }),
    )

    const { positions, height } = calculateAbsolutePositions(dimensions, width)

    return (
      <div style={{ width, height: height }}>
        {codes.map((codeObj, i) => {
          var pos = positions[i]
          const { width, height } = dimensions[i]
          return (
            <CodeBlock
              key={codeObj.uniqueKey}
              {...codeObj}
              onClick={() => this.onClick_(codeObj)}
              style={{
                left: pos.left,
                top: pos.top,
                width: width - 2,
                height: height - 2,
              }}
            />
          )
        })}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Form/City/Pickup/FlyerCodesGiveOutWidget/DraggableCodeList/DraggableList.js